module.exports = __webpack_public_path__ + "img/user-6.4e6e83dd.png";